const LocalStorageText = {
    Token: 'token'
}

const InitState = 'init'

const apiGetFile = "https://dev.digiin.vn/"

export { LocalStorageText, InitState, apiGetFile }
